<div class="modal-lg">
<div class="modal-header">
    <h4 class="modal-title">Kontakt</h4>
    <button type="button" class="close" aria-label="Close" (click)="closeModal()">
        <span aria-hidden="true">&times;</span>
      </button>

  </div>
  <div class="modal-body">
    <button class="btn addButton" (click)="openModalKontakt(null)">Erstellen</button>

<div class="table table-striped table-bordered table-responsive">
    <table class="table">
        <thead>
            <tr>
                <th>Ansprechpartner</th>
                <th>Telefon</th>
                <th>E-Mail</th>
                <th>Notizen</th>
                <th>Aktionen</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngIf="kontakte.length == 0">
                <td colspan="4" class="text-center">Keine Kontaktdaten vorhanden</td>
            </tr>
            <tr *ngFor="let element of kontakte">
                <td>{{ element.ansprechpartner }}</td>
                <td>{{ element.telefon }}</td>
                <td>{{ element.email }}</td>
                <td>{{ element.notizen }}</td>
                <td>
                    <button class="btn btn-float bg-blue editBtn" (click)="openModalKontakt(element)"><i
                            class="fa fa-edit"></i>
                        Bearbeiten</button>
                    <button class="popup-with-form btn btn-float bg-red" (click)="deleteKontakt(element)"
                        style="color: white;"><i class="fa fa-trash-o"></i>
                        Löschen</button>
                </td>
            </tr>
        </tbody>
    </table>
</div>

  </div>
</div>